export enum BrowserWarningType {
    Session,
    UpcommingSession,
    SessionStarted,
    SessionStartedWide,
}
